import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/Blog',
    name: 'Blog',
    component: () => import('../views/Blog.vue'),
    meta: {
      title: 'Blog Pendidikan | Pickiddo',
      description: 'Artikel pendidikan, tips peperiksaan SPM, dan panduan belajar untuk pelajar Malaysia'
    }
  },
  {
    path: '/BlogAuthorLogin',
    name: 'BlogAuthorLogin',
    component: () => import('../views/BlogAuthorLogin.vue'),
    meta: {
      title: 'Admin Login | Pickiddo Blog'
    }
  },
  {
    path: '/UploadBlogArticle',
    name: 'UploadBlogArticle',
    component: () => import('../views/UploadBlogArticle.vue'),
    meta: {
      title: 'Upload Artikel | Pickiddo Blog'
    }
  },
  {
    path: '/ManageBlog',
    name: 'ManageBlog',
    component: () => import('../views/ManageBlog.vue'),
    meta: {
      title: 'Urus Blog | Pickiddo Blog'
    }
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Index.vue'),
    meta: {
      title: 'Pickiddo – Tuisyen Online Terbaik Malaysia | SPM, UASA, UPKK & IGCSE',
      description: 'Platform tuisyen online terbaik Malaysia dengan 600+ tutor berpengalaman.'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Pickiddo Blog'
  next()
})

export default router
